import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { Buffer } from 'buffer'
import { FaPlus, FaTrophy, FaList, FaCheck, FaTimes, FaImage, FaEdit, FaGift, FaCog } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminLeagueService from "../../../services/league_services"
import CardService from "../../../services/card_services"
import BusinessService from "../../../services/business_services"

// Game rules available for a league (ids from the game settings "game_rules")
const GAME_RULES = [
    { id: 0, name: 'Classic', description: 'Basic classic rules of the game.' },
    { id: 1, name: 'Lock', description: 'A random card of the deck is locked and cannot be played during the game.' },
]

class AdminLeagues extends Component {
    constructor(props) {
        super(props)
        this.state = {
            leagues: [],
            buds: [],
            fileData: null,
            fileSize: 0,
            fileExtension: null,
            fileIRLData: null,
            fileIRLSize: 0,
            fileIRLExtension: null,
            deactivated: false,
            selectKey: null,
            order: 'asc',
            selected: [],
            processing: false,
            name: null,
            display: "browse",
            error: null,
            businesses: [],
            business_uuid: null,
            irl_description: null,
            irl_rules: null,
            start_day: 0,
            start_hour: 3,
            end_day: 6,
            end_hour: 20,
            // Modal states
            showBackgroundModal: false,
            showQuestModal: false,
            showBudRewardModal: false,
            showEditLeagueModal: false,
            selectedLeague: null,
            selectedQuest: null,
            // Edit league form states
            edit_name: null,
            edit_min_deck: null,
            edit_max_deck: null,
            edit_min_level: null,
            edit_max_level: null,
            edit_min_safe: null,
            edit_max_safe: null,
            edit_start_color: null,
            edit_end_color: null,
            edit_start_day: null,
            edit_start_hour: null,
            edit_end_day: null,
            edit_end_hour: null,
            edit_r1: null, edit_r2: null, edit_r3: null, edit_r4: null, edit_r5: null,
            edit_r6: null, edit_r7: null, edit_r8: null, edit_r9: null, edit_r10: null,
            edit_g1: null, edit_g2: null, edit_g3: null, edit_g4: null, edit_g5: null,
            edit_g6: null, edit_g7: null, edit_g8: null, edit_g9: null, edit_g10: null,
            edit_bud_reward: null,
            edit_view_order: null,
            edit_auto_update_bud: true,
            edit_game_rule: 0,
            edit_launch_date: null,
            edit_close_date: null,
            // Board & Logo file states
            fileBoardData: null,
            fileBoardSize: 0,
            fileBoardExtension: null,
            fileLogoData: null,
            fileLogoSize: 0,
            fileLogoExtension: null,
            // Create form extra fields
            view_order: 0,
            auto_update_bud: true,
            game_rule: 0,
            launch_date: null,
            close_date: null,
            g1: null, g2: null, g3: null, g4: null, g5: null,
            g6: null, g7: null, g8: null, g9: null, g10: null,
            previous_league: null,
            activeLeagues: [],
        }
    }

    componentDidMount = async () => {
        this.loadBuds()
        this.loadBusinesses()
        this.loadActiveLeagues()
        await this.loadLeagues()
    }

    loadBuds = async () => {
        const buds = await CardService.getBuds(this.state.deactivated, this.state.target)
        this.setState({ buds })
    }

    loadLeagues = async () => {
        const leagues = await AdminLeagueService.loadLeagues(this.state.deactivated)
        this.setState({ leagues })
    }

    loadActiveLeagues = async () => {
        const activeLeagues = await AdminLeagueService.loadLeagues(false)
        this.setState({ activeLeagues })
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let leagues = this.state.leagues
        if (order === 'asc')
            leagues.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
        else
            leagues.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        this.setState({ leagues })
    }

    onFileHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['png', 'jpg'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            this.setState({ fileSize: event.target.files[0].size, fileExtension: extension })
            reader.onloadend = () => this.processFile(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processFile = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ fileData: `data:image/${this.state.fileExtension};base64,${base64data}` })
    }

    onIRLFileHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['png', 'jpg'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            this.setState({ fileIRLSize: event.target.files[0].size, fileIRLExtension: extension })
            reader.onloadend = () => this.processIRLFile(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processIRLFile = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ fileIRLData: `data:image/${this.state.fileIRLExtension};base64,${base64data}` })
    }

    onBoardFileHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['png', 'jpg'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            this.setState({ fileBoardSize: event.target.files[0].size, fileBoardExtension: extension })
            reader.onloadend = () => this.processBoardFile(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processBoardFile = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ fileBoardData: `data:image/${this.state.fileBoardExtension};base64,${base64data}` })
    }

    onLogoFileHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['png', 'jpg'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            this.setState({ fileLogoSize: event.target.files[0].size, fileLogoExtension: extension })
            reader.onloadend = () => this.processLogoFile(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processLogoFile = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ fileLogoData: `data:image/${this.state.fileLogoExtension};base64,${base64data}` })
    }

    createNewLeague = async () => {
        if (window.confirm("Do you confirm league creation?")) {
            if (!this.state.r1 || !this.state.r2 || !this.state.r3 || !this.state.r4 || !this.state.r5 || !this.state.r6 || !this.state.r7 || !this.state.r8 || !this.state.r9 || !this.state.r10)
                return NotificationManager.error('Missing coin rewards')
            else if (!this.state.g1 || !this.state.g2 || !this.state.g3 || !this.state.g4 || !this.state.g5 || !this.state.g6 || !this.state.g7 || !this.state.g8 || !this.state.g9 || !this.state.g10)
                return NotificationManager.error('Missing gem rewards')
            else if (!this.state.min_deck || !this.state.max_deck)
                return NotificationManager.error('Missing deck PWR')
            else if (!this.state.min_safe || !this.state.max_safe)
                return NotificationManager.error('Missing safe values')
            else if (!this.state.start_color)
                return NotificationManager.error('Missing nb start color')
            else if (!this.state.end_color)
                return NotificationManager.error('Missing nb end color')
            else if (!this.state.name)
                return NotificationManager.error('Missing league name')
            else if (!this.state.title)
                return NotificationManager.error('Missing quest title')
            else if (!this.state.nb_victory)
                return NotificationManager.error('Missing nb victory')
            else if (!this.state.fileData)
                return NotificationManager.error('Missing background')
            else if (this.state.start_day === null || this.state.start_day === '')
                return NotificationManager.error('Missing start day')
            else if (this.state.start_hour === null || this.state.start_hour === '')
                return NotificationManager.error('Missing start hour')
            else if (this.state.end_day === null || this.state.end_day === '')
                return NotificationManager.error('Missing end day')
            else if (this.state.end_hour === null || this.state.end_hour === '')
                return NotificationManager.error('Missing end hour')
            else {
                //this.setState({ processing: true })
                console.log("HERE")
                const league_uuid = await AdminLeagueService.createLeague(
                    this.state.name,
                    this.state.min_deck,
                    this.state.max_deck,
                    this.state.min_safe,
                    this.state.max_safe,
                    [parseInt(this.state.r1),
                    parseInt(this.state.r2),
                    parseInt(this.state.r3),
                    parseInt(this.state.r4),
                    parseInt(this.state.r5),
                    parseInt(this.state.r6),
                    parseInt(this.state.r7),
                    parseInt(this.state.r8),
                    parseInt(this.state.r9),
                    parseInt(this.state.r10)],
                    [parseInt(this.state.g1),
                    parseInt(this.state.g2),
                    parseInt(this.state.g3),
                    parseInt(this.state.g4),
                    parseInt(this.state.g5),
                    parseInt(this.state.g6),
                    parseInt(this.state.g7),
                    parseInt(this.state.g8),
                    parseInt(this.state.g9),
                    parseInt(this.state.g10)],
                    this.state.bud_reward,
                    this.state.start_color,
                    this.state.end_color,
                    this.state.fileData,
                    this.state.business_uuid,
                    parseInt(this.state.start_day),
                    parseInt(this.state.start_hour),
                    parseInt(this.state.end_day),
                    parseInt(this.state.end_hour),
                    this.state.view_order !== null && this.state.view_order !== '' ? parseInt(this.state.view_order) : 0,
                    this.state.auto_update_bud,
                    this.state.launch_date || null,
                    this.state.close_date || null,
                    this.state.fileBoardData || null,
                    this.state.fileLogoData || null,
                    this.state.previous_league || null,
                    parseInt(this.state.game_rule) || 0,
                )
                if (!league_uuid) NotificationManager.error('Error creating the league')
                else {
                    const status = await AdminLeagueService.createLeagueQuest(
                        this.state.title,
                        league_uuid,
                        parseInt(this.state.nb_victory),
                        this.state.bud_uuid,
                        this.state.nb_coins ? parseInt(this.state.nb_coins) : this.state.nb_coins,
                        this.state.nb_gems ? parseInt(this.state.nb_gems) : this.state.nb_gems,
                        this.state.fileIRLData ? {
                            description: this.state.irl_description,
                            img_data: this.state.fileIRLData,
                            rules: this.state.irl_rules,
                        } : null,
                    )
                    if (status) {
                        NotificationManager.success('League created')
                        this.setState({ display: 'browse' })
                    }
                    else NotificationManager.error('Error creating the quest')
                }
                await this.loadLeagues()
                //this.setState({ processing: false })
            }
        }
    }

    activateLeague = async (league_uuid) => {
        await AdminLeagueService.activateLeague(league_uuid)
        this.loadLeagues()
    }

    deactivateLeague = async (league_uuid) => {
        await AdminLeagueService.deactivateLeague(league_uuid)
        this.loadLeagues()
    }

    // Modal handlers
    openBackgroundModal = (league) => {
        this.setState({ 
            showBackgroundModal: true, 
            selectedLeague: league,
            fileData: null 
        })
    }

    closeBackgroundModal = () => {
        this.setState({ 
            showBackgroundModal: false, 
            selectedLeague: null,
            fileData: null 
        })
    }

    openQuestModal = (league, quest) => {
        this.setState({ 
            showQuestModal: true, 
            selectedLeague: league,
            selectedQuest: quest,
            quest_title: quest.title || null,
            quest_nb_victory: quest.nb_victory || null,
            quest_nb_coins: quest.rewards?.nb_coins || null,
            quest_nb_gems: quest.rewards?.nb_gems || null,
            bud_uuid: null,
            irl_description: quest.rewards?.irl?.description || null,
            irl_rules: quest.rewards?.irl?.rules || null,
            fileIRLData: null
        })
    }

    closeQuestModal = () => {
        this.setState({ 
            showQuestModal: false, 
            selectedLeague: null,
            selectedQuest: null,
            quest_title: null,
            quest_nb_victory: null,
            quest_nb_coins: null,
            quest_nb_gems: null,
            bud_uuid: null,
            irl_description: null,
            irl_rules: null,
            fileIRLData: null
        })
    }

    openBudRewardModal = (league) => {
        this.setState({ 
            showBudRewardModal: true, 
            selectedLeague: league,
            bud_reward: null 
        })
    }

    closeBudRewardModal = () => {
        this.setState({ 
            showBudRewardModal: false, 
            selectedLeague: null,
            bud_reward: null
        })
    }

    openEditLeagueModal = (league) => {
        this.setState({ 
            showEditLeagueModal: true, 
            selectedLeague: league,
            edit_name: league.name,
            edit_min_deck: league.deck_power?.min,
            edit_max_deck: league.deck_power?.max,
            edit_min_level: league.level?.min,
            edit_max_level: league.level?.max,
            edit_min_safe: league.safe?.min,
            edit_max_safe: league.safe?.max,
            edit_start_color: league.start_color,
            edit_end_color: league.end_color,
            edit_start_day: league.start_day,
            edit_start_hour: league.start_hour,
            edit_end_day: league.end_day,
            edit_end_hour: league.end_hour,
            edit_r1: league.reward?.coins?.[0],
            edit_r2: league.reward?.coins?.[1],
            edit_r3: league.reward?.coins?.[2],
            edit_r4: league.reward?.coins?.[3],
            edit_r5: league.reward?.coins?.[4],
            edit_r6: league.reward?.coins?.[5],
            edit_r7: league.reward?.coins?.[6],
            edit_r8: league.reward?.coins?.[7],
            edit_r9: league.reward?.coins?.[8],
            edit_r10: league.reward?.coins?.[9],
            edit_g1: league.reward?.gems?.[0],
            edit_g2: league.reward?.gems?.[1],
            edit_g3: league.reward?.gems?.[2],
            edit_g4: league.reward?.gems?.[3],
            edit_g5: league.reward?.gems?.[4],
            edit_g6: league.reward?.gems?.[5],
            edit_g7: league.reward?.gems?.[6],
            edit_g8: league.reward?.gems?.[7],
            edit_g9: league.reward?.gems?.[8],
            edit_g10: league.reward?.gems?.[9],
            edit_bud_reward: league.reward?.bud?.bud_uuid || null,
            edit_view_order: league.view_order !== undefined ? league.view_order : 0,
            edit_auto_update_bud: league.auto_update_bud !== undefined ? league.auto_update_bud : true,
            edit_game_rule: league.game_rule !== undefined && league.game_rule !== null ? league.game_rule : 0,
            edit_launch_date: league.launch_date || '',
            edit_close_date: league.close_date || '',
            edit_previous_league: league.previous_league || null,
            fileData: null,
            fileBoardData: null,
            fileLogoData: null,
        })
    }

    closeEditLeagueModal = () => {
        this.setState({ 
            showEditLeagueModal: false, 
            selectedLeague: null,
            edit_name: null,
            edit_min_deck: null,
            edit_max_deck: null,
            edit_min_level: null,
            edit_max_level: null,
            edit_min_safe: null,
            edit_max_safe: null,
            edit_start_color: null,
            edit_end_color: null,
            edit_start_day: null,
            edit_start_hour: null,
            edit_end_day: null,
            edit_end_hour: null,
            edit_r1: null, edit_r2: null, edit_r3: null, edit_r4: null, edit_r5: null,
            edit_r6: null, edit_r7: null, edit_r8: null, edit_r9: null, edit_r10: null,
            edit_g1: null, edit_g2: null, edit_g3: null, edit_g4: null, edit_g5: null,
            edit_g6: null, edit_g7: null, edit_g8: null, edit_g9: null, edit_g10: null,
            edit_bud_reward: null,
            edit_view_order: null,
            edit_auto_update_bud: true,
            edit_game_rule: 0,
            edit_launch_date: null,
            edit_close_date: null,
            edit_previous_league: null,
            fileData: null,
            fileBoardData: null,
            fileLogoData: null,
        })
    }

    updateLeague = async () => {
        const updateData = {}
        
        if (this.state.edit_name) updateData.name = this.state.edit_name
        if (this.state.edit_min_deck) updateData.min_deck = parseInt(this.state.edit_min_deck)
        if (this.state.edit_max_deck) updateData.max_deck = parseInt(this.state.edit_max_deck)
        if (this.state.edit_min_level) updateData.min_level = parseInt(this.state.edit_min_level)
        if (this.state.edit_max_level) updateData.max_level = parseInt(this.state.edit_max_level)
        if (this.state.edit_min_safe) updateData.min_safe = parseInt(this.state.edit_min_safe)
        if (this.state.edit_max_safe) updateData.max_safe = parseInt(this.state.edit_max_safe)
        if (this.state.edit_start_color) updateData.start_color = this.state.edit_start_color
        if (this.state.edit_end_color) updateData.end_color = this.state.edit_end_color
        if (this.state.edit_start_day !== null) updateData.start_day = parseInt(this.state.edit_start_day)
        if (this.state.edit_start_hour !== null) updateData.start_hour = parseInt(this.state.edit_start_hour)
        if (this.state.edit_end_day !== null) updateData.end_day = parseInt(this.state.edit_end_day)
        if (this.state.edit_end_hour !== null) updateData.end_hour = parseInt(this.state.edit_end_hour)
        if (this.state.edit_bud_reward) updateData.bud_reward = this.state.edit_bud_reward
        if (this.state.fileData) updateData.background = this.state.fileData
        if (this.state.fileBoardData) updateData.board = this.state.fileBoardData
        if (this.state.fileLogoData) updateData.logo = this.state.fileLogoData
        if (this.state.edit_view_order !== null && this.state.edit_view_order !== '') updateData.view_order = parseInt(this.state.edit_view_order)
        updateData.auto_update_bud = this.state.edit_auto_update_bud
        updateData.game_rule = parseInt(this.state.edit_game_rule) || 0
        if (this.state.edit_launch_date) updateData.launch_date = this.state.edit_launch_date
        else updateData.launch_date = false
        if (this.state.edit_close_date) updateData.close_date = this.state.edit_close_date
        else updateData.close_date = false
        if (this.state.edit_previous_league === false) updateData.previous_league = false
        else if (this.state.edit_previous_league) updateData.previous_league = this.state.edit_previous_league
        
        const coins_rewards = [
            this.state.edit_r1, this.state.edit_r2, this.state.edit_r3, this.state.edit_r4, this.state.edit_r5,
            this.state.edit_r6, this.state.edit_r7, this.state.edit_r8, this.state.edit_r9, this.state.edit_r10
        ]
        if (coins_rewards.some(r => r !== null)) {
            updateData.coins_rewards = coins_rewards.map(r => parseInt(r))
        }
        
        const gems_rewards = [
            this.state.edit_g1, this.state.edit_g2, this.state.edit_g3, this.state.edit_g4, this.state.edit_g5,
            this.state.edit_g6, this.state.edit_g7, this.state.edit_g8, this.state.edit_g9, this.state.edit_g10
        ]
        if (gems_rewards.some(r => r !== null)) {
            updateData.gems_rewards = gems_rewards.map(r => parseInt(r))
        }

        try {
            const status = await AdminLeagueService.updateLeague(this.state.selectedLeague.league_uuid, updateData)
            if (status) {
                NotificationManager.success('League updated successfully')
                this.closeEditLeagueModal()
                await this.loadLeagues()
            } else {
                NotificationManager.error('Failed to update league')
            }
        } catch (e) {
            NotificationManager.error(e.response?.data?.message || 'Error updating league')
        }
    }

    updateBudLeagueReward = async () => {
        if (!this.state.bud_reward) {
            NotificationManager.error('Please select a bud')
            return
        }
        await AdminLeagueService.updateBudLeagueReward(this.state.selectedLeague.league_uuid, this.state.bud_reward)
        NotificationManager.success('League bud reward updated')
        await this.loadLeagues()
        this.closeBudRewardModal()
    }

    updateQuest = async () => {
        const updateData = {
            quest_uuid: this.state.selectedQuest.league_quest_uuid
        }

        // Add optional fields only if they have values
        if (this.state.quest_title) updateData.title = this.state.quest_title
        if (this.state.quest_nb_victory) updateData.nb_victory = parseInt(this.state.quest_nb_victory)
        if (this.state.quest_nb_coins) updateData.nb_coins = parseInt(this.state.quest_nb_coins)
        if (this.state.quest_nb_gems) updateData.nb_gems = parseInt(this.state.quest_nb_gems)
        if (this.state.bud_uuid) updateData.bud_uuid = this.state.bud_uuid
        
        // Handle IRL reward if any IRL field is updated
        if (this.state.irl_description || this.state.irl_rules || this.state.fileIRLData) {
            updateData.irl_reward = {}
            if (this.state.irl_description) updateData.irl_reward.description = this.state.irl_description
            if (this.state.irl_rules) updateData.irl_reward.rules = this.state.irl_rules
            if (this.state.fileIRLData) updateData.irl_reward.img_data = this.state.fileIRLData
        }

        try {
            const status = await AdminLeagueService.updateQuest(updateData)
            if (status) {
                NotificationManager.success('Quest updated successfully')
                await this.loadLeagues()
                this.closeQuestModal()
            } else {
                NotificationManager.error('Failed to update quest')
            }
        } catch (e) {
            NotificationManager.error(e.response?.data?.message || 'Error updating quest')
        }
    }

    updateLeagueBackground = async () => {
        if (!this.state.fileData) {
            NotificationManager.error('Please select a background image')
            return
        }
        await AdminLeagueService.updateLeagueBackground(this.state.selectedLeague.league_uuid, this.state.fileData)
        NotificationManager.success('Background updated')
        await this.loadLeagues()
        this.closeBackgroundModal()
    }

    loadBusinesses = async () => {
        let businesses = await BusinessService.businesses(false, true)
        businesses.sort((a, b) => a.business_name.localeCompare(b.business_name))
        this.setState({ businesses })
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Leagues Management"
                    breadcrumbs={[{ label: 'Leagues' }]}
                >
                    <div className="space-y-6">
                        {/* Action Buttons */}
                        <div className="flex flex-wrap gap-3">
                            {this.state.display === "browse" ? (
                                <button 
                                    onClick={() => this.setState({ display: "create" })}
                                    className="px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaPlus />
                                    Create League
                                </button>
                            ) : (
                                <button 
                                    onClick={() => this.setState({ display: "browse" })}
                                    className="px-4 py-2 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-lg hover:from-gray-600 hover:to-gray-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaList />
                                    Browse Leagues
                                </button>
                            )}
                            
                            {this.state.display === "browse" && (
                                <button 
                                    onClick={() => this.setState({ deactivated: !this.state.deactivated }, () => this.loadLeagues())}
                                    className={`px-4 py-2 rounded-lg transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2 ${
                                        this.state.deactivated 
                                            ? 'bg-gray-500 text-white hover:bg-gray-600' 
                                            : 'bg-green-500 text-white hover:bg-green-600'
                                    }`}
                                >
                                    {this.state.deactivated ? 'Show Active' : 'Show Deactivated'}
                                </button>
                            )}
                        </div>

                        {this.state.processing ? (
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
                                <p className="text-gray-600">Processing... please wait</p>
                            </div>
                        ) : (
                            <>
                                {/* Create League Form */}
                                {this.state.display === "create" && (
                                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 space-y-6">
                                        <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                            <FaTrophy className="text-yellow-500" />
                                            New League Configuration
                                        </h3>

                                        {/* League Name */}
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">League Name *</label>
                                            <input 
                                                type="text" 
                                                placeholder="League name" 
                                                value={this.state.name || ''} 
                                                onChange={(e) => this.setState({ name: e.target.value })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        {/* Background */}
                                        <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-lg p-4 border border-gray-200">
                                            <h4 className="text-sm font-semibold text-gray-800 mb-3">Background & Colors</h4>
                                            <div className="space-y-3">
                                                <input 
                                                    type="file" 
                                                    onChange={(e) => this.onFileHandler(e)}
                                                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-yellow-50 file:text-yellow-700 hover:file:bg-yellow-100 cursor-pointer"
                                                />
                                                <div className="grid grid-cols-2 gap-3">
                                                    <input 
                                                        type="text" 
                                                        placeholder="# Start color" 
                                                        value={this.state.start_color || ''} 
                                                        onChange={(e) => this.setState({ start_color: e.target.value })}
                                                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none text-sm"
                                                    />
                                                    <input 
                                                        type="text" 
                                                        placeholder="# End color" 
                                                        value={this.state.end_color || ''} 
                                                        onChange={(e) => this.setState({ end_color: e.target.value })}
                                                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none text-sm"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Power & Levels */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Deck Power Range *</label>
                                                <div className="flex gap-2">
                                                    <input 
                                                        type="number" 
                                                        placeholder="Min" 
                                                        value={this.state.min_deck || ''} 
                                                        onChange={(e) => this.setState({ min_deck: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                    />
                                                    <input 
                                                        type="number" 
                                                        placeholder="Max" 
                                                        value={this.state.max_deck || ''} 
                                                        onChange={(e) => this.setState({ max_deck: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Player Level Range</label>
                                                <div className="flex gap-2">
                                                    <input 
                                                        type="number" 
                                                        placeholder="Min" 
                                                        value={this.state.min_level || ''} 
                                                        onChange={(e) => this.setState({ min_level: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                    />
                                                    <input 
                                                        type="number" 
                                                        placeholder="Max" 
                                                        value={this.state.max_level || ''} 
                                                        onChange={(e) => this.setState({ max_level: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                    />
                                                </div>
                                            </div>

                                            <div className="md:col-span-2">
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Safe Range *</label>
                                                <div className="flex gap-2">
                                                    <input 
                                                        type="number" 
                                                        placeholder="Min Safe" 
                                                        value={this.state.min_safe || ''} 
                                                        onChange={(e) => this.setState({ min_safe: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                    />
                                                    <input 
                                                        type="number" 
                                                        placeholder="Max Safe" 
                                                        value={this.state.max_safe || ''} 
                                                        onChange={(e) => this.setState({ max_safe: e.target.value })}
                                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Coin Rewards */}
                                        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                                            <h4 className="text-sm font-semibold text-amber-800 mb-3 flex items-center gap-2">
                                                🪙 Ranking Coin Rewards (R1-R10) *
                                            </h4>
                                            <div className="grid grid-cols-5 md:grid-cols-10 gap-2">
                                                {[1,2,3,4,5,6,7,8,9,10].map(i => (
                                                    <input 
                                                        key={`r${i}`}
                                                        type="number" 
                                                        placeholder={`R${i}`} 
                                                        value={this.state[`r${i}`] || ''} 
                                                        onChange={(e) => this.setState({ [`r${i}`]: e.target.value })}
                                                        className="px-2 py-2 border border-amber-300 rounded-lg focus:ring-2 focus:ring-amber-500 outline-none text-sm text-center"
                                                    />
                                                ))}
                                            </div>
                                        </div>

                                        {/* Gem Rewards */}
                                        <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                                            <h4 className="text-sm font-semibold text-purple-800 mb-3 flex items-center gap-2">
                                                💎 Ranking Gem Rewards (R1-R10) *
                                            </h4>
                                            <div className="grid grid-cols-5 md:grid-cols-10 gap-2">
                                                {[1,2,3,4,5,6,7,8,9,10].map(i => (
                                                    <input 
                                                        key={`g${i}`}
                                                        type="number" 
                                                        placeholder={`G${i}`} 
                                                        value={this.state[`g${i}`] || ''} 
                                                        onChange={(e) => this.setState({ [`g${i}`]: e.target.value })}
                                                        className="px-2 py-2 border border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none text-sm text-center"
                                                    />
                                                ))}
                                            </div>
                                        </div>

                                        {/* Bud Reward */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Bud Reward</label>
                                            <select 
                                                onChange={(e) => this.setState({ bud_reward: e.target.value })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                defaultValue=""
                                            >
                                                <option value="" disabled>Select a bud</option>
                                                {this.state.buds.map(bud =>
                                                    <option key={bud.bud_uuid} value={bud.bud_uuid}>
                                                        {bud.bud_name} [{bud.bud_level}]
                                                    </option>
                                                )}
                                            </select>
                                        </div>

                                        {/* Business Selection */}
                                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                            <h4 className="text-sm font-semibold text-blue-800 mb-3">Merchant Association (Optional)</h4>
                                            <select 
                                                onChange={(e) => this.setState({ business_uuid: e.target.value })}
                                                className="w-full px-3 py-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                                                defaultValue=""
                                            >
                                                <option value="">No merchant</option>
                                                {this.state.businesses.map(business =>
                                                    <option key={business.business_uuid} value={business.business_uuid}>
                                                        {business.business_name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>

                                        {/* League Timing */}
                                        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
                                            <h4 className="text-sm font-semibold text-indigo-800 mb-3">League Schedule *</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-xs font-medium text-indigo-700 mb-2">Start Day (0-6)</label>
                                                    <input 
                                                        type="number" 
                                                        min="0" 
                                                        max="6" 
                                                        placeholder="0 = Monday" 
                                                        value={this.state.start_day} 
                                                        onChange={(e) => this.setState({ start_day: e.target.value })}
                                                        className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                                    />
                                                    <span className="text-xs text-gray-500 mt-1 block">0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun</span>
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-indigo-700 mb-2">Start Hour (0-23)</label>
                                                    <input 
                                                        type="number" 
                                                        min="0" 
                                                        max="23" 
                                                        placeholder="Hour" 
                                                        value={this.state.start_hour} 
                                                        onChange={(e) => this.setState({ start_hour: e.target.value })}
                                                        className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-indigo-700 mb-2">End Day (0-6)</label>
                                                    <input 
                                                        type="number" 
                                                        min="0" 
                                                        max="6" 
                                                        placeholder="0 = Monday" 
                                                        value={this.state.end_day} 
                                                        onChange={(e) => this.setState({ end_day: e.target.value })}
                                                        className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                                    />
                                                    <span className="text-xs text-gray-500 mt-1 block">0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun</span>
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-indigo-700 mb-2">End Hour (0-23)</label>
                                                    <input 
                                                        type="number" 
                                                        min="0" 
                                                        max="23" 
                                                        placeholder="Hour" 
                                                        value={this.state.end_hour} 
                                                        onChange={(e) => this.setState({ end_hour: e.target.value })}
                                                        className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* View Order & Auto Update Bud */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">View Order</label>
                                                <p className="text-xs text-gray-500 mb-2">Higher value = displayed first in the app</p>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    placeholder="0"
                                                    value={this.state.view_order !== null ? this.state.view_order : ''}
                                                    onChange={(e) => this.setState({ view_order: e.target.value })}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                                />
                                            </div>
                                            <div className="flex items-center gap-3 pt-6">
                                                <input
                                                    type="checkbox"
                                                    id="create_auto_update_bud"
                                                    checked={this.state.auto_update_bud}
                                                    onChange={(e) => this.setState({ auto_update_bud: e.target.checked })}
                                                    className="w-5 h-5 rounded border-gray-300 text-yellow-500 focus:ring-yellow-500"
                                                />
                                                <div>
                                                    <label htmlFor="create_auto_update_bud" className="text-sm font-medium text-gray-700 cursor-pointer">Auto Update Bud</label>
                                                    <p className="text-xs text-gray-500">Automatically update the bud reward</p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Game Rule */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Game Rule</label>
                                            <select
                                                value={this.state.game_rule}
                                                onChange={(e) => this.setState({ game_rule: parseInt(e.target.value) })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                            >
                                                {GAME_RULES.map((rule) => (
                                                    <option key={rule.id} value={rule.id}>{rule.name}</option>
                                                ))}
                                            </select>
                                            <p className="text-xs text-gray-500 mt-1">{GAME_RULES.find((rule) => rule.id === this.state.game_rule)?.description}</p>
                                        </div>

                                        {/* Launch & Close Dates */}
                                        <div className="bg-teal-50 border border-teal-200 rounded-lg p-4">
                                            <h4 className="text-sm font-semibold text-teal-800 mb-3">Availability Dates (Optional)</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-xs font-medium text-teal-700 mb-2">Launch Date</label>
                                                    <input
                                                        type="date"
                                                        value={this.state.launch_date || ''}
                                                        onChange={(e) => this.setState({ launch_date: e.target.value || null })}
                                                        className="w-full px-3 py-2 border border-teal-300 rounded-lg focus:ring-2 focus:ring-teal-500 outline-none text-sm"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-medium text-teal-700 mb-2">Close Date</label>
                                                    <input
                                                        type="date"
                                                        value={this.state.close_date || ''}
                                                        onChange={(e) => this.setState({ close_date: e.target.value || null })}
                                                        className="w-full px-3 py-2 border border-teal-300 rounded-lg focus:ring-2 focus:ring-teal-500 outline-none text-sm"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Game Board & Custom Logo */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                                                <h4 className="text-sm font-semibold text-yellow-800 mb-3">Game Board (Optional)</h4>
                                                <input
                                                    type="file"
                                                    onChange={(e) => this.onBoardFileHandler(e)}
                                                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-yellow-100 file:text-yellow-700 hover:file:bg-yellow-200 cursor-pointer"
                                                />
                                                {this.state.fileBoardData && (
                                                    <img src={this.state.fileBoardData} className="w-full h-24 rounded-lg mt-2 object-cover border-2 border-yellow-400" alt="Board preview" />
                                                )}
                                            </div>
                                            <div className="bg-rose-50 border border-rose-200 rounded-lg p-4">
                                                <h4 className="text-sm font-semibold text-rose-800 mb-1">Custom Logo (Optional)</h4>
                                                <p className="text-xs text-rose-600 mb-2">Replaces the LoyalBuds logo for this league</p>
                                                <input
                                                    type="file"
                                                    onChange={(e) => this.onLogoFileHandler(e)}
                                                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-rose-100 file:text-rose-700 hover:file:bg-rose-200 cursor-pointer"
                                                />
                                                {this.state.fileLogoData && (
                                                    <img src={this.state.fileLogoData} className="w-16 h-16 rounded-lg mt-2 object-cover border-2 border-rose-400" alt="Logo preview" />
                                                )}
                                            </div>
                                        </div>

                                        {/* Previous League */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Previous League (Optional)</label>
                                            <select 
                                                value={this.state.previous_league || ''}
                                                onChange={(e) => this.setState({ previous_league: e.target.value || null })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 outline-none"
                                            >
                                                <option value="">No previous league</option>
                                                {this.state.activeLeagues.map(league =>
                                                    <option key={league.league_uuid} value={league.league_uuid}>
                                                        {league.name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>

                                        {/* Quest Configuration */}
                                        <div className="bg-green-50 border border-green-200 rounded-lg p-4 space-y-4">
                                            <h4 className="text-sm font-semibold text-green-800">Associated Quest *</h4>
                                            
                                            <input 
                                                type="text" 
                                                placeholder="Quest title" 
                                                value={this.state.title || ''} 
                                                onChange={(e) => this.setState({ title: e.target.value })}
                                                className="w-full px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                            />

                                            {this.state.business_uuid ? (
                                                // IRL Quest
                                                <>
                                                    <input 
                                                        type="number" 
                                                        placeholder="Number of victories required" 
                                                        value={this.state.nb_victory || ''} 
                                                        onChange={(e) => this.setState({ nb_victory: e.target.value })}
                                                        className="w-full px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                                    />
                                                    <input 
                                                        type="text" 
                                                        placeholder="IRL Quest description" 
                                                        value={this.state.irl_description || ''} 
                                                        onChange={(e) => this.setState({ irl_description: e.target.value })}
                                                        className="w-full px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                                    />
                                                    <input 
                                                        type="text" 
                                                        placeholder="IRL Quest rules" 
                                                        value={this.state.irl_rules || ''} 
                                                        onChange={(e) => this.setState({ irl_rules: e.target.value })}
                                                        className="w-full px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                                    />
                                                    <div>
                                                        <label className="block text-xs font-medium text-green-700 mb-1">IRL Reward Visual</label>
                                                        <input 
                                                            type="file" 
                                                            onChange={(e) => this.onIRLFileHandler(e)}
                                                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-100 file:text-green-700 hover:file:bg-green-200 cursor-pointer"
                                                        />
                                                    </div>
                                                </>
                                            ) : (
                                                // Regular Quest
                                                <>
                                                    <div className="grid grid-cols-3 gap-3">
                                                        <input 
                                                            type="number" 
                                                            placeholder="Victories" 
                                                            value={this.state.nb_victory || ''} 
                                                            onChange={(e) => this.setState({ nb_victory: e.target.value })}
                                                            className="px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                                        />
                                                        <input 
                                                            type="number" 
                                                            placeholder="Coins" 
                                                            value={this.state.nb_coins || ''} 
                                                            onChange={(e) => this.setState({ nb_coins: e.target.value })}
                                                            className="px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                                        />
                                                        <input 
                                                            type="number" 
                                                            placeholder="Gems" 
                                                            value={this.state.nb_gems || ''} 
                                                            onChange={(e) => this.setState({ nb_gems: e.target.value })}
                                                            className="px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-green-700 mb-1">Bud Quest Reward</label>
                                                        <select 
                                                            onChange={(e) => this.setState({ bud_uuid: e.target.value })}
                                                            className="w-full px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 outline-none"
                                                            defaultValue=""
                                                        >
                                                            <option value="" disabled>Select a bud</option>
                                                            {this.state.buds.map(bud =>
                                                                <option key={bud.bud_uuid} value={bud.bud_uuid}>
                                                                    {bud.bud_name} [{bud.bud_level}]
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className="flex justify-end">
                                            {!this.state.processing ? (
                                                <button 
                                                    onClick={this.createNewLeague}
                                                    className="px-6 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-lg hover:from-yellow-600 hover:to-orange-600 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                                >
                                                    <FaPlus />
                                                    Create League & Quest
                                                </button>
                                            ) : (
                                                <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg">Processing...</div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Browse Leagues Table */}
                                {this.state.display === "browse" && (
                                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                        <div className="overflow-x-auto">
                                            <table className="w-full">
                                                <thead className="bg-gradient-to-r from-yellow-50 to-orange-50 border-b border-gray-200">
                                                    <tr>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-12">#</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Name</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-48">Background</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Quest</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-24">Victories</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">PWR</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Safe</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Level</th>
                                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-32">Rewards</th>
                                                        <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-48">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200">
                                                    {this.state.leagues.map((league, index) => (
                                                        <tr key={`league_${league.league_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                            <td className="px-4 py-3 font-semibold text-gray-700">{index + 1}</td>
                                                            <td className="px-4 py-3">
                                                <div>
                                                    <span className="font-medium text-gray-900">{league.name}</span>
                                                    <div className="flex flex-wrap items-center gap-1 mt-1">
                                                        {league.view_order > 0 && (
                                                            <span className="text-xs bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded font-medium">#{league.view_order}</span>
                                                        )}
                                                        {league.game_rule > 0 && (
                                                            <span className="text-xs bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded">{GAME_RULES.find((rule) => rule.id === league.game_rule)?.name || `Rule ${league.game_rule}`}</span>
                                                        )}
                                                        {league.auto_update_bud && (
                                                            <span className="text-xs bg-green-100 text-green-700 px-1.5 py-0.5 rounded">Auto</span>
                                                        )}
                                                        {league.launch_date && (
                                                            <span className="text-xs text-gray-500">from {league.launch_date}</span>
                                                        )}
                                                        {league.close_date && (
                                                            <span className="text-xs text-gray-500">to {league.close_date}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                                            
                                                            {/* Background */}
                                                            <td className="px-4 py-3">
                                                                <img src={league.background} className="w-32 h-20 rounded-lg object-cover border border-gray-300 shadow-sm" alt="League background" />
                                                                {league.logo && (
                                                                    <img src={league.logo} className="w-10 h-10 rounded border border-gray-300 mt-1 object-cover" alt="League logo" title="Custom logo" />
                                                                )}
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                {league.quest && league.quest[0] && (
                                                                    <div className="space-y-1">
                                                                        <p className="text-sm font-medium text-gray-900">{league.quest[0].title}</p>
                                                                        {league.quest[0].rewards?.bud && (
                                                                            <div className="flex items-center gap-2">
                                                                                <img src={league.quest[0].rewards.bud.thumbnail_url} className="w-10 h-10 rounded border border-gray-300" alt="bud" />
                                                                                <div>
                                                                                    <p className="text-xs font-semibold text-gray-800">{league.quest[0].rewards.bud.bud_name}</p>
                                                                                    <p className="text-xs text-gray-600">[{league.quest[0].rewards.bud.bud_level}]</p>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {league.quest[0].rewards?.irl && (
                                                                            <span className="inline-flex items-center px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium">
                                                                                IRL Quest
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td className="px-4 py-3 text-sm text-gray-700">
                                                                {league.quest && league.quest[0] && league.quest[0].nb_victory}
                                                            </td>
                                                            <td className="px-4 py-3 text-xs text-gray-600">{league.deck_power.min} → {league.deck_power.max}</td>
                                                            <td className="px-4 py-3 text-xs text-gray-600">{league.safe.min} → {league.safe.max}</td>
                                                            <td className="px-4 py-3 text-xs text-gray-600">{league.level.min} → {league.level.max}</td>
                                                            
                                                            {/* Rewards Summary */}
                                                            <td className="px-4 py-3">
                                                                <div className="space-y-1">
                                                                    <div className="text-xs text-gray-700">
                                                                        🪙 Top: {league.reward.coins?.[0] || 0}
                                                                    </div>
                                                                    <div className="text-xs text-gray-700">
                                                                        💎 Top: {league.reward.gems?.[0] || 0}
                                                                    </div>
                                                                    {league.reward.bud && (
                                                                        <div className="flex items-center gap-1">
                                                                            <img src={league.reward.bud.thumbnail_url || league.reward.bud.img_url} className="w-6 h-6 rounded border border-gray-300" alt="bud" />
                                                                            <span className="text-xs text-gray-700">{league.reward.bud.bud_name}</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>

                                                            {/* Actions */}
                                                            <td className="px-4 py-3">
                                                                <div className="flex flex-col gap-1.5">
                                                                    <button 
                                                                        onClick={() => this.openEditLeagueModal(league)}
                                                                        className="px-2 py-1 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 transition-colors text-xs font-medium flex items-center justify-center gap-1"
                                                                        title="Edit League"
                                                                    >
                                                                        <FaCog />
                                                                        Edit League
                                                                    </button>
                                                                    <button 
                                                                        onClick={() => this.openBackgroundModal(league)}
                                                                        className="px-2 py-1 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-xs font-medium flex items-center justify-center gap-1"
                                                                        title="Update Background"
                                                                    >
                                                                        <FaImage />
                                                                        Background
                                                                    </button>
                                                                    {league.quest && league.quest[0] && (
                                                                        <button 
                                                                            onClick={() => this.openQuestModal(league, league.quest[0])}
                                                                            className="px-2 py-1 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors text-xs font-medium flex items-center justify-center gap-1"
                                                                            title="Update Quest"
                                                                        >
                                                                            <FaEdit />
                                                                            Quest
                                                                        </button>
                                                                    )}
                                                                    <button 
                                                                        onClick={() => this.openBudRewardModal(league)}
                                                                        className="px-2 py-1 bg-purple-100 text-purple-700 rounded-lg hover:bg-purple-200 transition-colors text-xs font-medium flex items-center justify-center gap-1"
                                                                        title="Update Bud Reward"
                                                                    >
                                                                        <FaGift />
                                                                        Bud Reward
                                                                    </button>
                                                                    {!league.deactivated ? (
                                                                        <button 
                                                                            onClick={() => this.deactivateLeague(league.league_uuid)}
                                                                            className="px-2 py-1 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors text-xs font-medium flex items-center justify-center gap-1"
                                                                        >
                                                                            <FaTimes />
                                                                            Deactivate
                                                                        </button>
                                                                    ) : (
                                                                        <button 
                                                                            onClick={() => this.activateLeague(league.league_uuid)}
                                                                            className="px-2 py-1 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors text-xs font-medium flex items-center justify-center gap-1"
                                                                        >
                                                                            <FaCheck />
                                                                            Activate
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </AdminLayout>

                {/* Background Modal */}
                {this.state.showBackgroundModal && this.state.selectedLeague && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
                            <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center justify-between">
                                <div className="flex items-center gap-3 text-white">
                                    <FaImage className="text-2xl" />
                                    <div>
                                        <h3 className="text-xl font-bold">Update Background</h3>
                                        <p className="text-sm text-white/90">
                                            League: {this.state.selectedLeague.name}
                                        </p>
                                    </div>
                                </div>
                                <button 
                                    onClick={this.closeBackgroundModal}
                                    className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                                >
                                    <FaTimes className="text-xl" />
                                </button>
                            </div>

                            <div className="p-6 space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Current Background</label>
                                    <img 
                                        src={this.state.selectedLeague.background} 
                                        className="w-full h-48 rounded-lg object-cover border border-gray-300" 
                                        alt="Current background" 
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Upload New Background</label>
                                    <input 
                                        type="file" 
                                        onChange={(e) => this.onFileHandler(e)}
                                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 cursor-pointer"
                                    />
                                </div>

                                {this.state.fileData && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Preview</label>
                                        <img 
                                            src={this.state.fileData} 
                                            className="w-full h-48 rounded-lg object-cover border-2 border-blue-500" 
                                            alt="Preview" 
                                        />
                                    </div>
                                )}

                                <div className="flex justify-end gap-3 pt-4">
                                    <button
                                        onClick={this.closeBackgroundModal}
                                        className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        onClick={this.updateLeagueBackground}
                                        disabled={!this.state.fileData}
                                        className={`px-6 py-2.5 rounded-lg transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2 ${
                                            this.state.fileData
                                                ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white hover:from-blue-600 hover:to-indigo-700'
                                                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                        }`}
                                    >
                                        <FaImage />
                                        Update Background
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Quest Modal */}
                {this.state.showQuestModal && this.state.selectedLeague && this.state.selectedQuest && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-4 flex items-center justify-between sticky top-0 z-10">
                                <div className="flex items-center gap-3 text-white">
                                    <FaEdit className="text-2xl" />
                                    <div>
                                        <h3 className="text-xl font-bold">Update Quest</h3>
                                        <p className="text-sm text-white/90">
                                            {this.state.selectedQuest.title}
                                        </p>
                                    </div>
                                </div>
                                <button 
                                    onClick={this.closeQuestModal}
                                    className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                                >
                                    <FaTimes className="text-xl" />
                                </button>
                            </div>

                            <div className="p-6 space-y-4">
                                {this.state.selectedQuest.rewards?.bud ? (
                                    // Bud Quest
                                    <>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Quest Title</label>
                                            <input 
                                                type="text" 
                                                placeholder="Quest title" 
                                                value={this.state.quest_title || ''}
                                                onChange={(e) => this.setState({ quest_title: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div className="grid grid-cols-3 gap-3">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Victories</label>
                                                <input 
                                                    type="number" 
                                                    placeholder="Victories" 
                                                    value={this.state.quest_nb_victory || ''}
                                                    onChange={(e) => this.setState({ quest_nb_victory: e.target.value })}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Coins</label>
                                                <input 
                                                    type="number" 
                                                    placeholder="Coins" 
                                                    value={this.state.quest_nb_coins || ''}
                                                    onChange={(e) => this.setState({ quest_nb_coins: e.target.value })}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Gems</label>
                                                <input 
                                                    type="number" 
                                                    placeholder="Gems" 
                                                    value={this.state.quest_nb_gems || ''}
                                                    onChange={(e) => this.setState({ quest_nb_gems: e.target.value })}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Current Bud Reward</label>
                                            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                                                <img 
                                                    src={this.state.selectedQuest.rewards.bud.thumbnail_url} 
                                                    className="w-16 h-16 rounded border border-gray-300" 
                                                    alt="bud" 
                                                />
                                                <div>
                                                    <p className="font-semibold text-gray-900">{this.state.selectedQuest.rewards.bud.bud_name}</p>
                                                    <p className="text-sm text-gray-600">[{this.state.selectedQuest.rewards.bud.bud_level}]</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Select New Bud (Optional)</label>
                                            <select 
                                                value={this.state.bud_uuid || ''}
                                                onChange={(e) => this.setState({ bud_uuid: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                            >
                                                <option value="">Keep current bud</option>
                                                {this.state.buds.map(bud =>
                                                    <option key={bud.bud_uuid} value={bud.bud_uuid}>
                                                        {bud.bud_name} [{bud.bud_level}]
                                                    </option>
                                                )}
                                            </select>
                                        </div>

                                        <div className="flex justify-end gap-3 pt-4">
                                            <button
                                                onClick={this.closeQuestModal}
                                                className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                            >
                                                Cancel
                                            </button>
                                            <button 
                                                onClick={this.updateQuest}
                                                className="px-6 py-2.5 rounded-lg transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700"
                                            >
                                                <FaEdit />
                                                Update Quest
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    // IRL Quest
                                    <>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Quest Title</label>
                                            <input 
                                                type="text" 
                                                placeholder="Quest title" 
                                                value={this.state.quest_title || ''}
                                                onChange={(e) => this.setState({ quest_title: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Number of Victories</label>
                                            <input 
                                                type="number" 
                                                placeholder="Number of victories" 
                                                value={this.state.quest_nb_victory || ''}
                                                onChange={(e) => this.setState({ quest_nb_victory: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                                            <input 
                                                type="text" 
                                                placeholder="IRL Quest description" 
                                                value={this.state.irl_description || ''}
                                                onChange={(e) => this.setState({ irl_description: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Rules</label>
                                            <input 
                                                type="text" 
                                                placeholder="IRL Quest rules" 
                                                value={this.state.irl_rules || ''}
                                                onChange={(e) => this.setState({ irl_rules: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        {this.state.selectedQuest.rewards?.irl?.img_url && (
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Current Image</label>
                                                <img 
                                                    src={this.state.selectedQuest.rewards?.irl?.img_url} 
                                                    className="w-32 h-32 rounded-lg border border-gray-300 object-cover" 
                                                    alt="IRL reward" 
                                                />
                                            </div>
                                        )}

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Upload New Image (Optional)</label>
                                            <input 
                                                type="file" 
                                                onChange={(e) => this.onIRLFileHandler(e)}
                                                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-100 file:text-green-700 hover:file:bg-green-200 cursor-pointer"
                                            />
                                        </div>

                                        {this.state.fileIRLData && (
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">Preview</label>
                                                <img 
                                                    src={this.state.fileIRLData} 
                                                    className="w-32 h-32 rounded-lg border-2 border-green-500 object-cover" 
                                                    alt="Preview" 
                                                />
                                            </div>
                                        )}

                                        <div className="flex justify-end gap-3 pt-4">
                                            <button
                                                onClick={this.closeQuestModal}
                                                className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                            >
                                                Cancel
                                            </button>
                                            <button 
                                                onClick={this.updateQuest}
                                                className="px-6 py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                            >
                                                <FaEdit />
                                                Update Quest
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Bud Reward Modal */}
                {this.state.showBudRewardModal && this.state.selectedLeague && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
                            <div className="bg-gradient-to-r from-purple-500 to-pink-600 px-6 py-4 flex items-center justify-between">
                                <div className="flex items-center gap-3 text-white">
                                    <FaGift className="text-2xl" />
                                    <div>
                                        <h3 className="text-xl font-bold">Update Bud Reward</h3>
                                        <p className="text-sm text-white/90">
                                            League: {this.state.selectedLeague.name}
                                        </p>
                                    </div>
                                </div>
                                <button 
                                    onClick={this.closeBudRewardModal}
                                    className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                                >
                                    <FaTimes className="text-xl" />
                                </button>
                            </div>

                            <div className="p-6 space-y-4">
                                {this.state.selectedLeague.reward?.bud && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Current Bud Reward</label>
                                        <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                                            <img 
                                                src={this.state.selectedLeague.reward.bud.thumbnail_url || this.state.selectedLeague.reward.bud.img_url} 
                                                className="w-16 h-16 rounded border border-gray-300" 
                                                alt="bud" 
                                            />
                                            <div>
                                                <p className="font-semibold text-gray-900">{this.state.selectedLeague.reward.bud.bud_name}</p>
                                                <p className="text-sm text-gray-600">[{this.state.selectedLeague.reward.bud.bud_level}]</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Select New Bud</label>
                                    <select 
                                        onChange={(e) => this.setState({ bud_reward: e.target.value })}
                                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                        defaultValue=""
                                    >
                                        <option value="" disabled>Choose a bud...</option>
                                        {this.state.buds.map(bud =>
                                            <option key={bud.bud_uuid} value={bud.bud_uuid}>
                                                {bud.bud_name} [{bud.bud_level}]
                                            </option>
                                        )}
                                    </select>
                                </div>

                                <div className="flex justify-end gap-3 pt-4">
                                    <button
                                        onClick={this.closeBudRewardModal}
                                        className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        onClick={this.updateBudLeagueReward}
                                        disabled={!this.state.bud_reward}
                                        className={`px-6 py-2.5 rounded-lg transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2 ${
                                            this.state.bud_reward
                                                ? 'bg-gradient-to-r from-purple-500 to-pink-600 text-white hover:from-purple-600 hover:to-pink-700'
                                                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                        }`}
                                    >
                                        <FaGift />
                                        Update Bud Reward
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Edit League Modal */}
                {this.state.showEditLeagueModal && this.state.selectedLeague && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
                        <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full my-8">
                            <div className="bg-gradient-to-r from-orange-500 to-amber-600 px-6 py-4 flex items-center justify-between sticky top-0 z-10 rounded-t-xl">
                                <div className="flex items-center gap-3 text-white">
                                    <FaCog className="text-2xl" />
                                    <div>
                                        <h3 className="text-xl font-bold">Edit League</h3>
                                        <p className="text-sm text-white/90">
                                            {this.state.selectedLeague.name}
                                        </p>
                                    </div>
                                </div>
                                <button 
                                    onClick={this.closeEditLeagueModal}
                                    className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                                >
                                    <FaTimes className="text-xl" />
                                </button>
                            </div>

                            <div className="p-6 space-y-6 max-h-[calc(100vh-200px)] overflow-y-auto">
                                {/* League Name */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">League Name</label>
                                    <input 
                                        type="text" 
                                        placeholder="League name" 
                                        value={this.state.edit_name || ''} 
                                        onChange={(e) => this.setState({ edit_name: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                {/* Background & Colors */}
                                <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-lg p-4 border border-gray-200">
                                    <h4 className="text-sm font-semibold text-gray-800 mb-3">Background & Colors</h4>
                                    <div className="space-y-3">
                                        {this.state.selectedLeague.background && !this.state.fileData && (
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">Current Background</label>
                                                <img src={this.state.selectedLeague.background} className="w-full h-32 rounded-lg object-cover border border-gray-300" alt="Current" />
                                            </div>
                                        )}
                                        <input 
                                            type="file" 
                                            onChange={(e) => this.onFileHandler(e)}
                                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-orange-50 file:text-orange-700 hover:file:bg-orange-100 cursor-pointer"
                                        />
                                        {this.state.fileData && (
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">New Background Preview</label>
                                                <img src={this.state.fileData} className="w-full h-32 rounded-lg object-cover border-2 border-orange-500" alt="Preview" />
                                            </div>
                                        )}
                                        <div className="grid grid-cols-2 gap-3">
                                            <input 
                                                type="text" 
                                                placeholder="# Start color" 
                                                value={this.state.edit_start_color || ''} 
                                                onChange={(e) => this.setState({ edit_start_color: e.target.value })}
                                                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none text-sm"
                                            />
                                            <input 
                                                type="text" 
                                                placeholder="# End color" 
                                                value={this.state.edit_end_color || ''} 
                                                onChange={(e) => this.setState({ edit_end_color: e.target.value })}
                                                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none text-sm"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Power & Levels */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Deck Power Range</label>
                                        <div className="flex gap-2">
                                            <input 
                                                type="number" 
                                                placeholder="Min" 
                                                value={this.state.edit_min_deck || ''} 
                                                onChange={(e) => this.setState({ edit_min_deck: e.target.value })}
                                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                            />
                                            <input 
                                                type="number" 
                                                placeholder="Max" 
                                                value={this.state.edit_max_deck || ''} 
                                                onChange={(e) => this.setState({ edit_max_deck: e.target.value })}
                                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Player Level Range</label>
                                        <div className="flex gap-2">
                                            <input 
                                                type="number" 
                                                placeholder="Min" 
                                                value={this.state.edit_min_level || ''} 
                                                onChange={(e) => this.setState({ edit_min_level: e.target.value })}
                                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                            />
                                            <input 
                                                type="number" 
                                                placeholder="Max" 
                                                value={this.state.edit_max_level || ''} 
                                                onChange={(e) => this.setState({ edit_max_level: e.target.value })}
                                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Safe Range</label>
                                        <div className="flex gap-2">
                                            <input 
                                                type="number" 
                                                placeholder="Min Safe" 
                                                value={this.state.edit_min_safe || ''} 
                                                onChange={(e) => this.setState({ edit_min_safe: e.target.value })}
                                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                            />
                                            <input 
                                                type="number" 
                                                placeholder="Max Safe" 
                                                value={this.state.edit_max_safe || ''} 
                                                onChange={(e) => this.setState({ edit_max_safe: e.target.value })}
                                                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* League Timing */}
                                <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
                                    <h4 className="text-sm font-semibold text-indigo-800 mb-3">League Schedule</h4>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-medium text-indigo-700 mb-2">Start Day (0-6)</label>
                                            <input 
                                                type="number" 
                                                min="0" 
                                                max="6" 
                                                placeholder="0 = Monday" 
                                                value={this.state.edit_start_day !== null ? this.state.edit_start_day : ''} 
                                                onChange={(e) => this.setState({ edit_start_day: e.target.value })}
                                                className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                            />
                                            <span className="text-xs text-gray-500 mt-1 block">0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun</span>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-indigo-700 mb-2">Start Hour (0-23)</label>
                                            <input 
                                                type="number" 
                                                min="0" 
                                                max="23" 
                                                placeholder="Hour" 
                                                value={this.state.edit_start_hour !== null ? this.state.edit_start_hour : ''} 
                                                onChange={(e) => this.setState({ edit_start_hour: e.target.value })}
                                                className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-indigo-700 mb-2">End Day (0-6)</label>
                                            <input 
                                                type="number" 
                                                min="0" 
                                                max="6" 
                                                placeholder="0 = Monday" 
                                                value={this.state.edit_end_day !== null ? this.state.edit_end_day : ''} 
                                                onChange={(e) => this.setState({ edit_end_day: e.target.value })}
                                                className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                            />
                                            <span className="text-xs text-gray-500 mt-1 block">0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun</span>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-indigo-700 mb-2">End Hour (0-23)</label>
                                            <input 
                                                type="number" 
                                                min="0" 
                                                max="23" 
                                                placeholder="Hour" 
                                                value={this.state.edit_end_hour !== null ? this.state.edit_end_hour : ''} 
                                                onChange={(e) => this.setState({ edit_end_hour: e.target.value })}
                                                className="w-full px-3 py-2 border border-indigo-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Coin Rewards */}
                                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                                    <h4 className="text-sm font-semibold text-amber-800 mb-3 flex items-center gap-2">
                                        🪙 Ranking Coin Rewards (R1-R10)
                                    </h4>
                                    <div className="grid grid-cols-5 md:grid-cols-10 gap-2">
                                        {[1,2,3,4,5,6,7,8,9,10].map(i => (
                                            <input 
                                                key={`edit_r${i}`}
                                                type="number" 
                                                placeholder={`R${i}`} 
                                                value={this.state[`edit_r${i}`] || ''} 
                                                onChange={(e) => this.setState({ [`edit_r${i}`]: e.target.value })}
                                                className="px-2 py-2 border border-amber-300 rounded-lg focus:ring-2 focus:ring-amber-500 outline-none text-sm text-center"
                                            />
                                        ))}
                                    </div>
                                </div>

                                {/* Gem Rewards */}
                                <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                                    <h4 className="text-sm font-semibold text-purple-800 mb-3 flex items-center gap-2">
                                        💎 Ranking Gem Rewards (R1-R10)
                                    </h4>
                                    <div className="grid grid-cols-5 md:grid-cols-10 gap-2">
                                        {[1,2,3,4,5,6,7,8,9,10].map(i => (
                                            <input 
                                                key={`edit_g${i}`}
                                                type="number" 
                                                placeholder={`G${i}`} 
                                                value={this.state[`edit_g${i}`] || ''} 
                                                onChange={(e) => this.setState({ [`edit_g${i}`]: e.target.value })}
                                                className="px-2 py-2 border border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none text-sm text-center"
                                            />
                                        ))}
                                    </div>
                                </div>

                                {/* Bud Reward */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Bud Reward</label>
                                    <select 
                                        value={this.state.edit_bud_reward || ''}
                                        onChange={(e) => this.setState({ edit_bud_reward: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                    >
                                        <option value="">Select a bud</option>
                                        {this.state.buds.map(bud =>
                                            <option key={bud.bud_uuid} value={bud.bud_uuid}>
                                                {bud.bud_name} [{bud.bud_level}]
                                            </option>
                                        )}
                                    </select>
                                </div>

                                {/* View Order & Auto Update Bud */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">View Order</label>
                                        <p className="text-xs text-gray-500 mb-2">Higher value = displayed first in the app</p>
                                        <input
                                            type="number"
                                            min="0"
                                            placeholder="0"
                                            value={this.state.edit_view_order !== null ? this.state.edit_view_order : ''}
                                            onChange={(e) => this.setState({ edit_view_order: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                        />
                                    </div>
                                    <div className="flex items-center gap-3 pt-6">
                                        <input
                                            type="checkbox"
                                            id="edit_auto_update_bud"
                                            checked={this.state.edit_auto_update_bud}
                                            onChange={(e) => this.setState({ edit_auto_update_bud: e.target.checked })}
                                            className="w-5 h-5 rounded border-gray-300 text-orange-500 focus:ring-orange-500"
                                        />
                                        <div>
                                            <label htmlFor="edit_auto_update_bud" className="text-sm font-medium text-gray-700 cursor-pointer">Auto Update Bud</label>
                                            <p className="text-xs text-gray-500">Automatically update the bud reward</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Game Rule */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Game Rule</label>
                                    <select
                                        value={this.state.edit_game_rule}
                                        onChange={(e) => this.setState({ edit_game_rule: parseInt(e.target.value) })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                    >
                                        {GAME_RULES.map((rule) => (
                                            <option key={rule.id} value={rule.id}>{rule.name}</option>
                                        ))}
                                    </select>
                                    <p className="text-xs text-gray-500 mt-1">{GAME_RULES.find((rule) => rule.id === this.state.edit_game_rule)?.description}</p>
                                </div>

                                {/* Launch & Close Dates */}
                                <div className="bg-teal-50 border border-teal-200 rounded-lg p-4">
                                    <h4 className="text-sm font-semibold text-teal-800 mb-1">Availability Dates (Optional)</h4>
                                    <p className="text-xs text-teal-600 mb-3">Clear a date field to remove it</p>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-medium text-teal-700 mb-2">Launch Date</label>
                                            <input
                                                type="date"
                                                value={this.state.edit_launch_date || ''}
                                                onChange={(e) => this.setState({ edit_launch_date: e.target.value })}
                                                className="w-full px-3 py-2 border border-teal-300 rounded-lg focus:ring-2 focus:ring-teal-500 outline-none text-sm"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-teal-700 mb-2">Close Date</label>
                                            <input
                                                type="date"
                                                value={this.state.edit_close_date || ''}
                                                onChange={(e) => this.setState({ edit_close_date: e.target.value })}
                                                className="w-full px-3 py-2 border border-teal-300 rounded-lg focus:ring-2 focus:ring-teal-500 outline-none text-sm"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Game Board & Custom Logo */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                                        <h4 className="text-sm font-semibold text-yellow-800 mb-2">Game Board (Optional)</h4>
                                        {this.state.selectedLeague?.board && !this.state.fileBoardData && (
                                            <img src={this.state.selectedLeague.board} className="w-full h-20 rounded-lg mb-2 object-cover border border-yellow-300" alt="Current board" />
                                        )}
                                        <input
                                            type="file"
                                            onChange={(e) => this.onBoardFileHandler(e)}
                                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-xs file:font-semibold file:bg-yellow-100 file:text-yellow-700 hover:file:bg-yellow-200 cursor-pointer"
                                        />
                                        {this.state.fileBoardData && (
                                            <img src={this.state.fileBoardData} className="w-full h-20 rounded-lg mt-2 object-cover border-2 border-yellow-400" alt="Board preview" />
                                        )}
                                    </div>
                                    <div className="bg-rose-50 border border-rose-200 rounded-lg p-4">
                                        <h4 className="text-sm font-semibold text-rose-800 mb-1">Custom Logo (Optional)</h4>
                                        <p className="text-xs text-rose-600 mb-2">Replaces the LoyalBuds logo</p>
                                        {this.state.selectedLeague?.logo && !this.state.fileLogoData && (
                                            <img src={this.state.selectedLeague.logo} className="w-12 h-12 rounded-lg mb-2 object-cover border border-rose-300" alt="Current logo" />
                                        )}
                                        <input
                                            type="file"
                                            onChange={(e) => this.onLogoFileHandler(e)}
                                            className="block w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-xs file:font-semibold file:bg-rose-100 file:text-rose-700 hover:file:bg-rose-200 cursor-pointer"
                                        />
                                        {this.state.fileLogoData && (
                                            <img src={this.state.fileLogoData} className="w-16 h-16 rounded-lg mt-2 object-cover border-2 border-rose-400" alt="Logo preview" />
                                        )}
                                    </div>
                                </div>

                                {/* Previous League */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Previous League (Optional)</label>
                                    <select 
                                        value={
                                            this.state.edit_previous_league === false
                                                ? '__remove__'
                                                : (this.state.edit_previous_league || '')
                                        }
                                        onChange={(e) => {
                                            const v = e.target.value
                                            if (v === '__remove__') this.setState({ edit_previous_league: false })
                                            else this.setState({ edit_previous_league: v || null })
                                        }}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                                    >
                                        <option value="">-</option>
                                        <option value="__remove__">Remove previous league</option>
                                        {this.state.activeLeagues.filter(l => l.league_uuid !== this.state.selectedLeague?.league_uuid).map(league =>
                                            <option key={league.league_uuid} value={league.league_uuid}>
                                                {league.name}
                                            </option>
                                        )}
                                    </select>
                                    {this.state.selectedLeague?.previous_league && this.state.edit_previous_league !== false && (
                                        <p className="text-xs text-gray-500 mt-1">
                                            Current: {this.state.activeLeagues.find(l => l.league_uuid === this.state.selectedLeague.previous_league)?.name || this.state.selectedLeague.previous_league}
                                        </p>
                                    )}
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                                    <button
                                        onClick={this.closeEditLeagueModal}
                                        className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        onClick={this.updateLeague}
                                        className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-amber-600 text-white rounded-lg hover:from-orange-600 hover:to-amber-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                    >
                                        <FaCog />
                                        Update League
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminLeagues)